import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import Input from '../../TravellerContactInfo/FormFields/Input';

import '../LoginModals.css';
import { If } from 'react-extras';
import { UserFlowModalState } from '../../UserFlow/UserFlowModal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const UserNotVerified = (props: UserFlowModalState) => {
  const [ state, setState ] = useState({
    showModal: props.showModal || false,
    validationFail: true,
  });

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const goToForgotUsernamePage=() => {
    props.switchModal('forgotUsername');
  };

  const goToIRCTCRegistrationPage=() => {
    props.createAccount();
  };
  const { userStatus: { userId }, switchModal, allowClose } = props;
  const { showModal, validationFail } = state;
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className="makeFlex spaceBetween appendBottom40">
        <span className="modalTitle font26 latoBloack blackText">
          {'Username doesn\'t exist'}
        </span>
        <If condition={allowClose === true}>
          <span
            className="modalClose railSprite crossIcon"
            onClick={closeModal}
          />
        </If>
      </p>
      <p className="vrtlSeperater" />
      <div className="makeFlex spaceBetween">
        <div className="leftPanel">
          <p className="font20 latoBold darkGreyText appendBottom2"> Why Verify? </p>
          <p className="font14 darkGreyText appendBottom50">
            <span className="yellowText"> This is a compulsory step</span> required by IRCTC to ensure that your booking does not fail after payment.
          </p>
          <div className={`makeFlex spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC Username"
              errorMessage={`Username ${userId} doesn’t exist.`}
              validationFail={validationFail}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              irctcUserId={userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
        </div>
        <div className="rightPanel">
          <p className="font20 latoBold darkGreyText appendBottom10">Forgot Username?</p>
          <p className="latoBold font14 greenText appendBottom15">We can help you recover it</p>
          <p className="font14 darkGreyText appendBottom30"> If you have registered with IRCTC, you can get username in your email inbox within 1-2 mins. </p>
          <button
            className="rightPanelBtn latoBold font12 deepskyBlueText appendBottom60 textCenter"
            onClick={goToForgotUsernamePage}
          >
              Forgot Username
          </button>
          <p className="font14 darkGreyText">Haven’t registered with IRCTC?</p>
          <a className="font16 latoBold" onClick={goToIRCTCRegistrationPage}>Create New Account</a>
        </div>
      </div>
    </Modal>
  );
};

UserNotVerified.propTypes = {
  showModal: PropTypes.bool.isRequired,
  switchModal: PropTypes.func.isRequired,
};

export default withRouter(UserNotVerified);
